import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildSeo, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/contact")({
  head: () => {
    const seo = buildSeo({
      title: "تواصل معنا | BAZZAR 3D — استشارة تصميم مجانية",
      description:
        "تواصل مع استوديو بازار ثري دي للتصميم الداخلي والنماذج ثلاثية الأبعاد — استشارة مجانية، عرض سعر خلال 24 ساعة، وخدمة في جميع أنحاء المملكة.",
      path: "/contact",
      keywords: "تواصل, بازار ثري دي, تصميم داخلي, استشارة, contact, BAZZAR 3D",
    });
    return {
      meta: seo.meta,
      links: seo.links,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbJsonLd([
              { name: "Home", path: "/" },
              { name: "Contact", path: "/contact" },
            ]),
          ),
        },
      ],
    };
  },
  component: lazyRouteComponent(() => import("@/pages-lazy/contact")),
});